import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = {
  key: 0,
  class: "filter-box"
}
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = {
  key: 0,
  class: "iconfont icon-tubiao-40"
}
const _hoisted_10 = { class: "status" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { style: {"display":"flex"} }
const _hoisted_13 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "公司名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.name) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              (_ctx.showSalesManFilter())
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.listQuery.salesManId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                      class: "filter-item",
                      placeholder: "",
                      clearable: "",
                      size: _ctx.t('table.btnSize'),
                      onChange: _ctx.handleFilter
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesManOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "size", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "审批状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.changeStatus,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.changeStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ReviewStatusOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        ref: "tableListRef",
        dataList: _ctx.list,
        columnAllData: _ctx.columnAllData,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        isShowPagination: false,
        canRefresh: false,
        canChangeColumn: false,
        onCommandChange: _ctx.handleCommand,
        highlightCurrentRow: true
      }, {
        name: _withCtx((scope) => [
          _createElementVNode("span", {
            class: _normalizeClass([scope.row.status === 1 ? 'redStatusStyle' : scope.row.status === 2 ? 'yellowStatusStyle' : '', "statusStyle"])
          }, [
            (scope.row.status !== 3)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.ReviewStatusOption.find(k => k.id === scope.row.status) ? _ctx.ReviewStatusOption.find(k => k.id === scope.row.status).mark : ''), 1),
            _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
          ], 2)
        ]),
        "operation-action": _withCtx((scope) => [
          (scope.row.status == 1)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode(" 审批 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_APPROVAL` }]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ]),
      _withDirectives(_createVNode(_component_el_pagination, {
        class: "mt-20",
        total: _ctx.total,
        currentPage: _ctx.listQuery.page,
        "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.page) = $event)),
        "page-size": _ctx.listQuery.size,
        "page-sizes": _ctx.pageSizes,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        layout: "total, sizes, prev, pager, next"
      }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
        [_vShow, _ctx.total > 0]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_FormComponent, {
              id: _ctx.activeId,
              initFormData: _ctx.initFormData,
              fromFieldData: _ctx.originFromFieldData,
              dialogFormVisible: _ctx.dialogFormVisible,
              api: 'customerCompany',
              isShowCloseBtn: false,
              isShowSubmitBtn: false,
              formDisabled: true
            }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible"]),
            _createVNode(_component_FormComponent, {
              id: _ctx.activeId,
              initFormData: _ctx.initFormData,
              fromFieldData: _ctx.targetFromFieldData,
              dialogFormVisible: _ctx.dialogFormVisible,
              api: 'customerCompany',
              isShowCloseBtn: false,
              isShowSubmitBtn: false,
              formDisabled: true
            }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_button, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogFormVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.submitLoading,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSubmit('approve')))
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode(" 通过 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, {
              type: "danger",
              loading: _ctx.submitLoading,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSubmit('reject')))
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode(" 拒绝 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}